import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { regularSignIn } from "../../../api/index";

@withRouter
class RegularAdmin extends Component{
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      confirmEmail: ''
    };
  }
  componentDidMount() {
    let handlerSubmit = this.handlerSubmit;
    $("#login-form").validate({
      rules: {
        email: {
          required: true,
          email: true
        },
        confirmEmail: {
          required: true,
          email: true,
          equalTo: "#email"
        }
      },
      messages: {
        email: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address'
        },
        confirmEmail: {
          required: 'Please enter your email address',
          email: 'Please enter a valid email address',
          equalTo:'Please enter the same email address'
        }
      },
      submitHandler: function(){
        handlerSubmit();
      },
      errorPlacement: function (error, element) {
        error.insertAfter(element.parent());
      }
    });
  }
  handlerSubmit = ()=>{
    let { email, confirmEmail } = this.state;
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    $("#submitBtn").button('loading');
    regularSignIn({email, confirmEmail}, {"headers": {'tenantname': tenantname}})
      .then(res=>{
        if (res.status === "success") {
          $.sound_on = false;
          $.SmartMessageBox({
            title : "Email notification",
            content : res.message,
            buttons : '[Confirm]'
          }, function(ButtonPress){
            if (ButtonPress === "Confirm") {
              $("#submitBtn").button("reset");
            }
          });
        }
        $("#submitBtn").button('reset');
      })
      .catch(e=>{
        $("#submitBtn").button('reset');
        console.log(e);
      });
  };
  render() {
    let companyName = this.props.companyName.toUpperCase();
    let {expire, expireMsg, headlineColor} = this.props;
    return (
      <div id="content" className="container">
        <div className="row" style={{marginTop: 14}}>
          <div className="well col-md-6 col-md-offset-3" style={{padding: 20}}>
            <h1 className="login-header-big tex-color-dangreen text-center"
                style={{color: headlineColor}}>
              {`${companyName} Alerts Subscription Management`}
              <br/>
              Administration Page
            </h1>
            <br/>
            <div className="col-md-8 col-md-offset-2">
              <div className="well no-padding">
                <form id="login-form" className="smart-form client-form">
                  <header className="text-center" style={{fontWeight: 400}}>
                    Sign In
                  </header>
                  {
                    expire &&
                    <div className="alert alert-danger alert-dismissible fade in"
                         role="alert"
                         style={{marginBottom: 0}}>
                      <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                      {
                        expireMsg ?
                        `Sorry, email is invalid, please login again` :
                        `Sorry, email has expired, please login again`
                      }
                    </div>
                  }
                  <fieldset>
                    <section>
                      <label className="label isos-label">E-mail</label>
                      <label className="input">
                        <i className="icon-append fa fa-user" />
                        <input
                          id="email"
                          type="email"
                          name="email"
                          onChange={v=>this.setState({email: v.target.value})}
                          style={{borderRadius: 5}} />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-user txt-color-teal" />
                          &nbsp;Please enter email address
                        </b>
                      </label>
                    </section>
                    <section>
                      <label className="label isos-label">Repeat Email</label>
                      <label className="input">
                        <i className="icon-append fa fa-user" />
                        <input
                          type="email"
                          name="confirmEmail"
                          onChange={v=>this.setState({confirmEmail: v.target.value})}
                          style={{borderRadius: 5}} />
                        <b className="tooltip tooltip-top-right">
                          <i className="fa fa-user txt-color-teal" />
                          &nbsp;Type your email address again
                        </b>
                      </label>
                    </section>
                  </fieldset>
                  <footer className="text-center">
                    <input
                      id="submitBtn"
                      type="submit"
                      value="Sign In"
                      className="btn btn-primary btn-lg"
                      style={{
                        float: "none",
                        borderRadius: 5
                      }}/>
                  </footer>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default RegularAdmin;


// WEBPACK FOOTER //
// ./src/container/regularLogin/model/regularAdmin.js